export default __webpack_public_path__ + "static/media/smile.f6590b3d.svg";